module.exports = __webpack_public_path__ + "img/gb-sct.d3cbf1a5.svg";